export const MESSAGE_TYPES = {
  USER: 'user',
  LIA: 'lia',
  TEXT: 'text',
  AUDIO: 'audio'
} as const;

export const MAX_AUDIO_RESPONSE_LENGTH = 300; 